import styled, { css } from 'styled-components'

export const StyledContainer = styled.div<{
  variant: 'sidebar' | 'card' | 'profile-card' | 'header'
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space3};

  ${({ variant, theme }) =>
    variant === 'card' &&
    css`
      background-color: ${theme.Components.Card.Fill};
      border: 1px solid ${theme.Components.Card.Border};
      color: ${theme.Components.Card.Text};
      padding: ${theme.UI.SpacingPx.Space3};
      border-radius: ${theme.UI.BorderRadius.Large}px;

      // Ensure it stands out a bit on white backgrounds if needed
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    `}

  ${({ variant, theme }) =>
    variant === 'sidebar' &&
    css`
      padding: 0;
      margin: ${theme.UI.SpacingPx.Space2} 0;
      width: 100%;
    `}

  ${({ variant, theme }) =>
    (variant === 'profile-card' || variant === 'header') &&
    css`
      gap: ${theme.UI.SpacingPx.Space3};
    `}

  ${({ variant, theme }) =>
    variant === 'header' &&
    css`
      padding-bottom: ${theme.UI.SpacingPx.Space2};
    `}
`

export const StyledLogo = styled.img<{
  variant: 'sidebar' | 'card' | 'profile-card' | 'header'
}>`
  max-height: 48px;
  max-width: 48px;
  object-fit: contain;
  flex-shrink: 0;

  ${({ variant }) =>
    variant === 'card' &&
    css`
      max-height: 40px;
      max-width: 40px;
    `}

  ${({ variant }) =>
    variant === 'sidebar' &&
    css`
      max-height: 24px;
      max-width: 24px;
    `}

  ${({ variant }) =>
    (variant === 'profile-card' || variant === 'header') &&
    css`
      max-height: 24px;
      max-width: 24px;
    `}

  ${({ variant }) =>
    variant === 'profile-card' &&
    css`
      max-height: 40px;
      max-width: 40px;
    `}
`

export const StyledTextContainer = styled.div<{
  variant: 'sidebar' | 'card' | 'profile-card' | 'header'
}>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;

  ${({ variant }) =>
    variant === 'sidebar' &&
    css`
      align-items: flex-start;
      text-align: left;
    `}
`
